import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';

import AnalyticsAssetList from '../../containers/analytics-asset-list';
import TrackAssetModal from '../../containers/track-asset-modal';
import { TRACKED_ASSET } from '../../utils/static-configuration';
import { setModal } from '../../actions/modal';
import PlainHeader from '../../components/plain-header';

class Analytics extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  showModal = docType => () => this.props.onSetModal(docType);

  render() {
    const { hasTrackedDeliverables } = this.props;

    return (
      <div className="page">
        { hasTrackedDeliverables &&
          <div className="white-header">
            <div className="row large">
              <div className="flex-spacer">
                <h1>Live analytics</h1>
              </div>
              <div className="flex-item" />
            </div>
            <div className="row">
              <div className="flex-item">
                <p>You can track Youtube, Facebook and Instagram deliverables. Twitter coming soon!</p>
              </div>
              <div className="flex-spacer" />
              <div className="flex-item">
                <div className="text-button-container">
                  <p><a onClick={this.showModal(TRACKED_ASSET)}>track a new deliverable </a></p>
                  <button className="medium rose add-button" onClick={this.showModal(TRACKED_ASSET)} >
                    <img className="image" src="/icons/add.svg" />
                  </button>
                </div>
              </div>
            </div>
            <div className="spacer" />
          </div>
        }
        { !hasTrackedDeliverables &&
          <div className="padded-content">
            <PlainHeader title="Live analytics" />
          </div>
        }
        <div className="page-content">
          <AnalyticsAssetList />
        </div>
        <TrackAssetModal />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasTrackedDeliverables: state.analyticsAssetList.get('hasTrackedDeliverables'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetModal: modalName => dispatch(setModal(modalName)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);



/** WEBPACK FOOTER **
 ** ./src/containers/analytics/index.js
 **/